import axios from 'axios';

const API = `${process.env.REACT_APP_API_BASE_URL}/profile`;

export const getSelfiesS3PresignedUrl = async (fileExtension) => {
  const resp = await axios.get(`${API}/selfie/presigned-url/${fileExtension}`);

  return resp.data;
};

export const getSelfieViewPresignedUrl = async () => {
  const resp = await axios.get(`${API}/selfie/view-presigned-url`);

  return resp.data;
};

export const contactUs = async (data) => await axios.post(`${API}/contact`, data);
